import styled from 'styled-components';
import React from 'react';
import createVariantSelector from '../theme/helpers/create-variant-selector';

export type ArticleDetailAuthorSize = 'small' | 'medium' | 'large';

export interface ArticleDetailAuthorVariantProps {
  size?: ArticleDetailAuthorSize;
}

export const variantSize = createVariantSelector<ArticleDetailAuthorVariantProps>(
  'size',
  ['small', 'medium', 'large'],
);
export interface ArticleDetailAuthorProps
  extends ArticleDetailAuthorVariantProps {
  imageUrl?: string;
  name?: string;
}

function ArticleDetailAuthor({
  imageUrl,
  name,
  size = 'medium',
}: ArticleDetailAuthorProps) {
  return (
    <ArticleDetailAuthorCss>
      {imageUrl && <ArticleDetailAuthorImageCss size={size} src={imageUrl} />}
      {name && (
        <ArticleDetailAuthorNameCss size={size}>
          {name}
        </ArticleDetailAuthorNameCss>
      )}
    </ArticleDetailAuthorCss>
  );
}

const ArticleDetailAuthorImageCss = styled.img<ArticleDetailAuthorVariantProps>`
  width: ${variantSize('sizes', ['spacing8', 'spacing9', 'spacing9'])};
  margin-right: ${p => p.theme.sizes.spacing3};
  border-radius: 50%;
`;

const ArticleDetailAuthorCss = styled.div`
  display: inline-flex;
  align-items: center;
`;

const ArticleDetailAuthorNameCss = styled.span<ArticleDetailAuthorVariantProps>`
  ${p => p.theme.getFontStyle('secondary', 'medium')}
  color: ${p => p.theme.articleDetailAuthor.nameColor};
  font-size: ${variantSize('typography', ['textXxxs', 'textXxs', 'textSm2'])};
  line-height: 1.8;
`;

export default ArticleDetailAuthor;
